import { render, staticRenderFns } from "./ButtonCreate.vue?vue&type=template&id=a66e95e2&scoped=true"
import script from "./ButtonCreate.vue?vue&type=script&lang=js"
export * from "./ButtonCreate.vue?vue&type=script&lang=js"
import style0 from "./ButtonCreate.vue?vue&type=style&index=0&id=a66e95e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a66e95e2",
  null
  
)

export default component.exports